export class TimeOfDay {
    hours: number = 0;
    minutes: number = 0;
    empty: boolean = false;

    constructor(hours: number, minutes: number) {
        if (hours < 0 || hours >= 24) {
            throw new Error("Invalid hours for TimeOfDay");
        }
        if (minutes < 0 || minutes >= 60) {
            throw new Error("Invalid minutes for TimeOfDay");
        }
        if (hours * 60 + minutes >= 24 * 60) {
            hours = 23;
            minutes = 59;
        }
        this.hours = hours;
        this.minutes = minutes;
    }

    get value() {
       return this.stringValue;
    }
    set value(val: string) {

        if (!TimeOfDay.isValidValue(val)){
            return;
        }

        let hours = 0;
        let minutes = 0;
        let parts = null;

        if (val.indexOf(":") > 0) {
            parts = val.split(":");
        }
        if (val.indexOf(".") > 0){
            parts = val.split(".");
        }
        if (parts) {
            hours = parseInt(parts[0], 10);
            minutes = parts.length > 1 ? parseInt(parts[1], 10) : 0;
        } else {
            switch (val.length) {
                case 1:
                case 2:
                    hours = parseInt(val, 10);
                    minutes = 0;
                    break;
                case 3:
                    hours = parseInt(val.substr(0, 1), 10);
                    minutes = parseInt(val.substr(1, 2), 10);
                    break;
                case 4:
                    hours = parseInt(val.substr(0, 2), 10);
                    minutes = parseInt(val.substr(2, 2), 10);
                    break;
                default:
                    break;
            }
        }
       
        if (hours < 0 || hours >= 24) {
            return;
        }
        if (minutes < 0 || minutes >= 60) {
            return;
        }
        if (hours * 60 + minutes >= 24 * 60) {
            hours = 23;
            minutes = 59;
        }
        this.hours = hours;
        this.minutes = minutes;
    }

    static isValidValue(value: string){
        let val = value;
        if (val.indexOf(":") > 0){
            val = val.replace(":", "");
        } else if (val.indexOf(".") > 0){
            val = val.replace("\.", "")
        }
        const hasNumbersOnly = /^\d+$/.test(val);
        return hasNumbersOnly && val.length > 0 && val.length < 5;
    }

    static fromMinutesFromMidnight(time: number) {
        if (typeof(time) !== 'number') {
            return;
        }
        const hours = Math.floor(time / 60);
        const minutes = time % 60;
        return new TimeOfDay(hours, minutes);
    }

    get stringValue() {
        return this.hours.toString().padStart(2, "0") + ":" +  this.minutes.toString().padStart(2, "0");
    }

    get totalMinutes() {
        return this.hours * 60 + this.minutes;
    }

    addMinutes(deltaMinutes: number) {
        const newTotalMinutes = this.totalMinutes + deltaMinutes;
        if (newTotalMinutes >= 0 && newTotalMinutes < (23 * 60 + 59)) {
            this.hours = Math.floor(newTotalMinutes / 60);
            this.minutes = newTotalMinutes - (this.hours * 60);
        }
    }

    matches(otherTimeOfDay: TimeOfDay){
        return this.hours === otherTimeOfDay.hours && this.minutes === otherTimeOfDay.minutes;
    }

}

export default TimeOfDay;
